export enum HousekeepingSort {
  RoomNumber = 'roomNumber',
  RoomType = 'roomType',
  FrontDeskStatus = 'frontdeskStatus',
  HousekeepingStatus = 'housekeepingStatus',
  RoomStatus = 'roomStatus',
  Sequence = 'displaySequence'
}



// WEBPACK FOOTER //
// ./src/components/Housekeeping/shared/enum/housekeepingSort.ts